import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
} from "@mui/material";
import { useLayoutEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { getSparePartLogList } from "../../store/actions/SparePartActions";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { sparePartActionEnumReverse } from "../../enums/sparePartActionEnum";

export default function SparePartHistoryPopup(props) {
  const { t } = useTranslation("translation");

  const { sparePartLogList } = useSelector(({ SparePart }) => SparePart);

  const rows = sparePartLogList?.resultObject || [];

  const dispatch = useDispatch();

  const fetchSparePartLogs = () => {
    let payload = {
      id: props.array.id,
    };
    if (!!props.array.id) {
      dispatch(getSparePartLogList(payload));
    }
  };

  useLayoutEffect(() => {
    fetchSparePartLogs();
  }, [props.array.id]);

  function sparePartDatePars(param) {
    const date = new Date(param);
    const locale = i18next.language || navigator.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const formatted = date.toLocaleString(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: timezone
    });
    return formatted;
  }

  return (
    <Container id="spHistory_Container">
      <Dialog id="spHistory_Dialog" open={props.open} onClose={props.close}>
        <DialogTitle id="spHistory_DialogTitle">{t("History")}</DialogTitle>
        <DialogContent id="spHistory_DialogContent">
          <TableContainer id="spHistory_TableContainer" component={Paper}>
            <Table id="spHistory_Table" aria-label="customized table">
              <TableHead id="spHistory_TableHead">
                <TableRow id="spHistory_TableRow">
                  <TableCell align="center">{t("TaskID")}</TableCell>
                  <TableCell align="center">{t("Type")}</TableCell>
                  <TableCell align="center">{t("AmountUsed")}</TableCell>
                  <TableCell align="center">{"Action"}</TableCell>
                  <TableCell align="center">{t("Note")}</TableCell>
                  <TableCell align="center">{t("SparePartDate")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody id="spHistory_TableBody">
                {rows.map((row, index) => (
                  <TableRow id={`spHistory_TableRow_${index}`} key={row.id}>
                    <TableCell
                      id={`spHistory_TableCell_Id`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      <Link
                        href={
                          row.type === "Planned"
                            ? `/planned-maintenance-detail?id=${row.taskId}`
                            : row.type === "UnPlanned"
                              ? `/breakdowndetail?id=${row.taskId}`
                              : "#"
                        }
                      >
                        {row.taskId}
                      </Link>
                    </TableCell>
                    <TableCell
                      id={`spHistory_TableCell_StockNo`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {t(row.type)}
                    </TableCell>
                    <TableCell
                      id={`spHistory_TableCell_MaterialDescription`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {row.amountUsed}
                    </TableCell>
                    <TableCell
                      id={`spHistory_TableCell_SparePartAction`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >{t(sparePartActionEnumReverse[row.sparePartAction])}
                    </TableCell>
                    <TableCell
                      id={`spHistory_TableCell_Note`}
                      align="center"
                      style={{ verticalAlign: "top" }}
                    >
                      {t(row.note)}
                    </TableCell>
                    <TableCell
                      id={`spHistory_TableCell_Id`}
                      align="center"
                      style={{ verticalAlign: "top" }}>
                      {sparePartDatePars(row.sparePartDate)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions id="spHistory_DialogActions">
          <Button id="spHistory_b" onClick={props.close} color="primary">
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
